import { useHasFF } from 'venn-utils';
import { useLegacyProxyState } from './useLegacyProxyState';
import { useLayeredProxyState } from './useLayeredProxyState';
import { type UseProxyPickerStateOptions, type ProxyPickerStateResult } from './types';

export function useProxyPickerState(options: UseProxyPickerStateOptions): ProxyPickerStateResult {
  const hasLayeredProxyFF = useHasFF('layered_proxy_picker_ff');

  const legacyResult = useLegacyProxyState(options);
  const layeredResult = useLayeredProxyState(options);

  return hasLayeredProxyFF ? layeredResult : legacyResult;
}
